import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { RefulfillmentInventoryPushRequest } from "./refulfillment-inventory-push-request";

/** Starts a push once per request ID; repeating a request returns the same run. */
export const startRefulfillmentInventoryPush = unaryRpc({
  name: "startRefulfillmentInventoryPush" as const,
  input: z.object({
    request: RefulfillmentInventoryPushRequest,
    requestId: z.uuid(),
  }),
  output: z.object({ workflowId: z.string() }),
});
